// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__32oKZ","file":"styles_file__1lAcV"};